import React from "react";

export const translations = {
  en: {
    // Header
    home: "Home",
    about: "About",
    products: "Products",
    news: "News",
    contact: "Contact",

    // Hero
    heroBadge: "Innovative Solutions",
    heroSubtitle:
      "We create cutting-edge software solutions that transform businesses and empower innovation",
    heroExpert: "Expert in software solutions, SaaS & mobile apps",
    btnDiscover: "Discover Our Products",
    btnContact: "Get In Touch",

    // About
    aboutBadge: "About Us",
    aboutTitle: "Building the future",
    aboutSubtitle: "One line of code at a time",
    aboutIntro:
      "At {company}, we bring deep expertise and passion for technology to every project. Led by seasoned professionals with extensive experience in IT management, software engineering, and strategic leadership.",
    expertise: "Architecture",
    expertiseDesc:
      "Design and deployment of scalable systems, microservices, and robust technical foundations",
    innovation: "Cybersecurity",
    innovationDesc:
      "Secure by design, identity management, and protection of your critical assets",
    mission: "Tourism",
    missionDesc:
      "Solutions and platforms tailored for the tourism and hospitality sector",
    solutions: "AI",
    solutionsDesc:
      "Intelligent automation, machine learning, and AI-powered products",

    // Products
    productsBadge: "Our Products",
    productsTitle: "Innovative Apps",
    productsSubtitle: "That make a difference",
    productsDescription:
      "Discover our portfolio of applications designed to solve real-world problems",
    learnMore: "Learn more",
    tagAI: "AI",
    tagCybersecurity: "Cybersecurity",
    tagMobile: "Mobile",
    tagSaaS: "SaaS",
    tagRAG: "RAG",
    tagGame: "Game",
    tagB2B: "B2B",
    tagProductivity: "Productivity",
    tagOnPremise: "On-premise",
    tagHosting: "Hosting",
    tagCompliance: "Compliance",

    // Partners
    partnersBadge: "Partners",
    partnersTitle: "Companies that work with us",
    partnersDescription: "Trusted by innovative businesses across sectors.",
    partnersEmpty: "Our partner logos will appear here soon.",

    // News
    newsBadge: "Latest",
    newsTitle: "News & Updates",
    newsDescription: "Stay tuned for product launches, tips, and company news.",
    readMore: "Read more",

    // Products descriptions
    masterSudokuDesc:
      "Challenge your mind with a variety of Sudoku puzzles. Perfect for beginners and experts alike.",
    sparkleDesc:
      "Streamline cleaning company operations with smart scheduling, task management, and client communications.",
    aiProductDesc:
      "Revolutionary AI-powered solutions that learn, adapt, and transform your business operations with intelligent automation.",
    comingSoon: "Coming Soon",
    probatDesc:
      "The mobile app for screed professionals. Track projects, manage sites, and simplify workflows.",
    passcryptDesc:
      "Cybersecurity suite for password management and secure access. Protect your credentials and simplify compliance.",
    pandagptDesc:
      "ChatGPT-like on-premise assistant based on open-source LLMs with custom RAG. Your data stays in-house.",
    vpsRamDesc:
      "RAM-oriented VPS hosting designed for high-memory workloads, fast response times, and reliable performance.",
    nf525Desc:
      "NF525 certification support to secure compliance for POS software, auditability, and fiscal data integrity.",

    // Contact
    contactBadge: "Get In Touch",
    contactTitle: "Let's Build Something Amazing Together",
    contactDescription: "Have a project in mind? We'd love to hear from you",
    email: "Email",
    support: "Support",
    getSupport: "Get Support",
    linkedin: "LinkedIn",
    followUs: "Follow Us",

    // Footer
    privacyPolicy: "Privacy Policy",
    supportLink: "Support",

    // Support page
    supportTitle: "YGALAAD – Support",
    supportIntro:
      "For any questions, technical issues, or feedback regarding our apps and services, please contact our support team:",
    supportResponse:
      "We aim to respond within 24 hours on business days. Thank you for choosing YGALAAD!",

    // Landing pages
    contactSupport: "Contact Support",
    masterSudokuTitle: "Master Sudoku Challenge",
    masterSudokuDescLong:
      "This app offers a variety of Sudoku puzzles to challenge your mind and improve your problem-solving skills. Whether you are a beginner or an expert, Master Sudoku Challenge has something for everyone.",
    sparkleTitle: "Sparkle",
    sparkleDescLong:
      "This app is designed to help with the organizing and scheduling of cleaning companies. Sparkle streamlines operations, making it easier to manage tasks, schedules, and client communications.",
    probatTitle: "ProBat",
    probatDescLong:
      "The mobile app for screed professionals and clients. Project tracking, site forms, site maps, client management, simple interface, time saver. Work smarter, save time, and focus on what matters most.",
    passcryptBadge: "Cybersecurity",
    passcryptTitle: "PassCrypt Suite",
    passcryptDescLong:
      "Cybersecurity suite for password management and secure access. PassCrypt helps you protect credentials, enforce policies, and simplify compliance for teams and organizations.",
    pandagptBadge: "AI & RAG",
    pandagptTitle: "PandaGPT",
    pandagptDescLong:
      "On-premise ChatGPT-like assistant powered by open-source LLMs. Deploy on your infrastructure with custom RAG to connect your documents and knowledge bases. Full control of your data, no cloud dependency.",
    nf525Badge: "Compliance",
    nf525Title: "NF525 Ready",
    nf525DescLong:
      "We support software publishers and merchants in obtaining NF525 certification. Our expertise covers the full compliance lifecycle: gap analysis, architecture recommendations, implementation of fiscal controls, and preparation for audit by an accredited body.",
    nf525WhatTitle: "What is NF525?",
    nf525WhatDesc:
      "NF525 is a French certification standard that ensures point-of-sale (POS) software meets requirements for immutability, security, data retention, and auditability. Since January 2018, all VAT-registered businesses in France using POS or cash register software must use a certified or attested solution.",
    nf525WhyTitle: "Why work with us?",
    nf525Why1: "Deep expertise in POS software architecture and fiscal regulations",
    nf525Why2: "End-to-end support from gap analysis to certification audit",
    nf525Why3: "Security-first approach: data integrity, tamper-proof logs, and encryption",
    nf525Why4: "Ongoing compliance monitoring and updates for regulatory changes",
    nf525HowTitle: "Our approach",
    nf525How1: "Audit of your existing system against NF525 requirements",
    nf525How2: "Technical recommendations and implementation roadmap",
    nf525How3: "Development of fiscal controls: signatures, sequential numbering, archiving",
    nf525How4: "Preparation and support during the certification audit",
    nf525Cta: "Contact Us",

    // Internship offer – Stagiaire Commercial
    stageTitle: "Sales & Marketing Intern",
    stageSubtitle: "Marketing / Business Development",
    stageTagMobile: "Tech Projects",
    stageFounder: "Founder",
    stageIntro1:
      "Entrepreneur and CTO, I develop and support several technology projects.",
    stageIntro2:
      "I am looking for a marketing / business development intern to structure and accelerate our commercial development strategy.",
    stageContext: "Context",
    stageContext1:
      "B2B SaaS products (Tourism, Construction, Cybersecurity), mobile applications (games)",
    stageContext2:
      "Design and deployment of RAG systems (Retrieval-Augmented Generation)",
    stageContext3: "Consulting in architecture and technical strategy",
    stageMissions: "Missions",
    stageMission1:
      "Identify and prioritise high-potential commercial opportunities",
    stageMission2: "Propose and implement acquisition strategies",
    stageMission3: "Structure the offering and refine the value proposition",
    stageProfile: "Ideal profile",
    stageProfile1:
      "Student from business school, IAE or tech/business double degree (L3/M1/M2)",
    stageProfile2: "Strong interest in tech and digital products",
    stageProfile3: "Analytical and structured mindset",
    stageProfile4: "Excellent writing skills (French, English appreciated)",
    stageProfile5: "Autonomy and curiosity",
    stageBenefits: "What the internship offers",
    stageBenefit1: "Direct work with a CTO / founder",
    stageBenefit2: "Full picture of product ↔ business",
    stageBenefit3: "Real impact on projects in development",
    stageBenefit4: "Strong accountability",
    stageBenefit5: "Possibility of long-term collaboration",
    stagePractical: "Practical information",
    stagePractical1: "Internship located in Grasse.",
    stagePractical2: "Duration: 6 months.",
    stagePractical5: "Application (CV + short message):",
    stageApply: "Apply (CV + short message)",
    stageDownloadPdf: "Download PDF offer",

    // Internship offer – Stagiaire Ingénieur / Developer
    stageEngineerTitle: "Intern – Developer",
    stageEngineerSubtitle: "Engineering / Architecture",
    stageEngineerTagMobile: "Mobile Apps",
    stageEngineerFounder: "Founder",
    stageEngineerIntro1:
      "Entrepreneur and CTO, I develop several technology products (B2B SaaS, mobile apps, RAG systems).",
    stageEngineerIntro2:
      "I am looking for an engineering intern willing to get involved in the design and evolution of these products, with a high level of technical responsibility.",
    stageEngineerContext: "Context",
    stageEngineerContext1:
      "B2B SaaS products (Tourism, Construction, Cybersecurity)",
    stageEngineerContext2: "Mobile applications (games and business tools)",
    stageEngineerContext3:
      "Design and deployment of RAG systems (Retrieval-Augmented Generation)",
    stageEngineerMissions: "Missions",
    stageEngineerMission1: "Design and evolve backend and mobile architectures",
    stageEngineerMission2:
      "Participate in structuring technical choices (stack, organization, scalability)",
    stageEngineerMission3:
      "Design and optimize RAG pipelines (ingestion, embeddings, retrieval, generation)",
    stageEngineerMission4:
      "Contribute directly to product robustness and performance",
    stageEngineerProfile: "Ideal profile",
    stageEngineerProfile1:
      "Student in engineering school or Master's in computer science (L3/M1/M2)",
    stageEngineerProfile2:
      "Solid foundations in algorithms and software design",
    stageEngineerProfile3:
      "Interest in software architecture and distributed systems",
    stageEngineerProfile4: "Strong curiosity for applied AI and RAG systems",
    stageEngineerProfile5: "Ability to propose, decide, and execute",
    stageEngineerBenefits: "What the internship offers",
    stageEngineerBenefit1: "Direct work with a CTO / founder",
    stageEngineerBenefit2: "Exposure to structuring technical decisions",
    stageEngineerBenefit3: "Direct and measurable impact on products",
    stageEngineerBenefit4: "Strong accountability",
    stageEngineerBenefit5: "Possibility of long-term collaboration",
    stageEngineerPractical: "Practical information",
    stageEngineerPractical1: "Internship located in Grasse.",
    stageEngineerPractical2: "Duration: 6 months.",
    stageEngineerPractical5: "Application (CV + short message):",
    stageEngineerApply: "Apply (CV + short message)",
    stageEngineerDownloadPdf: "Download PDF offer",
    stageOtherOffer: "Also see: Sales & Marketing Intern",
    stageOtherOfferEngineer: "Also see: Developer Intern",
  },
  fr: {
    // Header
    home: "Accueil",
    about: "À propos",
    products: "Produits",
    news: "Actualités",
    contact: "Contact",

    // Hero
    heroBadge: "Solutions Innovantes",
    heroSubtitle:
      "Nous créons des solutions logicielles de pointe qui transforment les entreprises et favorisent l'innovation",
    heroExpert: "Expert en solutions logicielles, SaaS & applications mobiles",
    btnDiscover: "Découvrir Nos Produits",
    btnContact: "Nous Contacter",

    // About
    aboutBadge: "À Propos",
    aboutTitle: "Construisons le futur",
    aboutSubtitle: "Une ligne de code à la fois",
    aboutIntro:
      "Chez {company}, nous apportons une expertise approfondie et une passion pour la technologie à chaque projet. Dirigés par des professionnels chevronnés avec une vaste expérience en gestion informatique, génie logiciel et leadership stratégique.",
    expertise: "Architecture",
    expertiseDesc:
      "Conception et déploiement de systèmes évolutifs, microservices et fondations techniques solides",
    innovation: "Cybersécurité",
    innovationDesc:
      "Sécurité dès la conception, gestion des identités et protection de vos actifs critiques",
    mission: "Tourisme",
    missionDesc:
      "Solutions et plateformes dédiées au secteur du tourisme et de l'hôtellerie",
    solutions: "IA",
    solutionsDesc:
      "Automatisation intelligente, machine learning et produits alimentés par l'IA",

    // Products
    productsBadge: "Nos Produits",
    productsTitle: "Applications innovantes",
    productsSubtitle: "Qui font la différence",
    productsDescription:
      "Découvrez notre portefeuille d'applications conçues pour résoudre des problèmes du monde réel",
    learnMore: "En savoir plus",
    tagAI: "IA",
    tagCybersecurity: "Cybersécurité",
    tagMobile: "Mobile",
    tagSaaS: "SaaS",
    tagRAG: "RAG",
    tagGame: "Jeu",
    tagB2B: "B2B",
    tagProductivity: "Productivité",
    tagOnPremise: "On-premise",
    tagHosting: "Hébergement",
    tagCompliance: "Conformité",

    // Partners
    partnersBadge: "Partenaires",
    partnersTitle: "Ils nous font confiance",
    partnersDescription: "Ils nous font confiance pour innover.",
    partnersEmpty: "Les logos de nos partenaires apparaîtront bientôt ici.",

    // News
    newsBadge: "Dernières",
    newsTitle: "Actualités & Mises à jour",
    newsDescription:
      "Restez informés des lancements, astuces et actualités de l'entreprise.",
    readMore: "Lire la suite",

    // Products descriptions
    masterSudokuDesc:
      "Défiez votre esprit avec une variété de puzzles Sudoku. Parfait pour les débutants et les experts.",
    sparkleDesc:
      "Rationalisez les opérations des entreprises de nettoyage avec une planification intelligente, la gestion des tâches et les communications clients.",
    aiProductDesc:
      "Solutions révolutionnaires alimentées par l'IA qui apprennent, s'adaptent et transforment vos opérations commerciales avec une automatisation intelligente.",
    comingSoon: "Bientôt disponible",
    probatDesc:
      "L'application mobile pour les professionnels de la chape. Suivez les projets, gérez les chantiers et simplifiez les flux de travail.",
    passcryptDesc:
      "Suite cybersécurité pour la gestion des mots de passe et l'accès sécurisé. Protégez vos identifiants et simplifiez la conformité.",
    pandagptDesc:
      "Assistant type ChatGPT on-premise basé sur des LLM open source avec RAG personnalisé. Vos données restent en interne.",
    vpsRamDesc:
      "Hébergement VPS orienté RAM, conçu pour les charges mémoire élevées, des temps de réponse rapides et une performance stable.",
    nf525Desc:
      "Accompagnement à la certification NF525 pour garantir la conformité des logiciels de caisse, la traçabilité et l'intégrité des données fiscales.",

    // Contact
    contactBadge: "Contactez-nous",
    contactTitle: "Construisons quelque chose d'extraordinaire ensemble",
    contactDescription:
      "Vous avez un projet en tête ? Nous serions ravis de vous entendre",
    email: "Email",
    support: "Support",
    getSupport: "Obtenir du Support",
    linkedin: "LinkedIn",
    followUs: "Nous Suivre",

    // Footer
    privacyPolicy: "Politique de Confidentialité",
    supportLink: "Support",

    // Support page
    supportTitle: "YGALAAD – Support",
    supportIntro:
      "Pour toute question, problème technique ou commentaire concernant nos applications et services, veuillez contacter notre équipe de support :",
    supportResponse:
      "Nous nous efforçons de répondre dans les 24 heures les jours ouvrables. Merci d'avoir choisi YGALAAD !",

    // Landing pages
    contactSupport: "Contacter le Support",
    masterSudokuTitle: "Master Sudoku Challenge",
    masterSudokuDescLong:
      "Cette application propose une variété de puzzles Sudoku pour défier votre esprit et améliorer vos compétences en résolution de problèmes. Que vous soyez débutant ou expert, Master Sudoku Challenge a quelque chose pour tout le monde.",
    sparkleTitle: "Sparkle",
    sparkleDescLong:
      "Cette application est conçue pour aider à l'organisation et à la planification des entreprises de nettoyage. Sparkle rationalise les opérations, facilitant la gestion des tâches, des horaires et des communications clients.",
    probatTitle: "ProBat",
    probatDescLong:
      "L'application mobile pour les professionnels et clients de la chape. Suivi de projets, formulaires de chantier, cartes de sites, gestion des clients, interface simple, gain de temps. Travaillez plus intelligemment, gagnez du temps et concentrez-vous sur l'essentiel.",
    passcryptBadge: "Cybersécurité",
    passcryptTitle: "La suite PassCrypt",
    passcryptDescLong:
      "Suite cybersécurité pour la gestion des mots de passe et l'accès sécurisé. PassCrypt vous aide à protéger les identifiants, appliquer les politiques et simplifier la conformité pour les équipes et les organisations.",
    pandagptBadge: "IA & RAG",
    pandagptTitle: "PandaGPT",
    pandagptDescLong:
      "Assistant type ChatGPT on-premise, propulsé par des LLM open source. Déployez sur votre infrastructure avec un RAG personnalisé pour connecter vos documents et bases de connaissances. Contrôle total de vos données, sans dépendance cloud.",
    nf525Badge: "Conformité",
    nf525Title: "NF525 Ready",
    nf525DescLong:
      "Nous accompagnons les éditeurs de logiciels et les commerçants dans l'obtention de la certification NF525. Notre expertise couvre l'ensemble du cycle de conformité : analyse d'écart, recommandations d'architecture, mise en œuvre des contrôles fiscaux et préparation à l'audit par un organisme accrédité.",
    nf525WhatTitle: "Qu'est-ce que la NF525 ?",
    nf525WhatDesc:
      "La NF525 est une norme de certification française qui garantit que les logiciels de caisse respectent les exigences d'inaltérabilité, de sécurisation, de conservation et d'archivage des données. Depuis le 1er janvier 2018, toute entreprise assujettie à la TVA en France utilisant un logiciel de caisse doit disposer d'une solution certifiée ou attestée.",
    nf525WhyTitle: "Pourquoi travailler avec nous ?",
    nf525Why1: "Expertise approfondie en architecture de logiciels de caisse et réglementations fiscales",
    nf525Why2: "Accompagnement de bout en bout, de l'analyse d'écart à l'audit de certification",
    nf525Why3: "Approche sécurité : intégrité des données, journaux inaltérables et chiffrement",
    nf525Why4: "Suivi continu de la conformité et mises à jour pour les évolutions réglementaires",
    nf525HowTitle: "Notre approche",
    nf525How1: "Audit de votre système existant par rapport aux exigences NF525",
    nf525How2: "Recommandations techniques et feuille de route de mise en œuvre",
    nf525How3: "Développement des contrôles fiscaux : signatures, numérotation séquentielle, archivage",
    nf525How4: "Préparation et accompagnement lors de l'audit de certification",
    nf525Cta: "Contactez-nous",

    // Offre de stage – Stagiaire Commercial
    stageTitle: "Stagiaire Commercial",
    stageSubtitle: "Marketing / Business Development",
    stageTagMobile: "Projets Tech",
    stageFounder: "Fondateur",
    stageIntro1:
      "Entrepreneur et CTO, je développe et accompagne plusieurs projets technologiques.",
    stageIntro2:
      "Je recherche un(e) stagiaire marketing / business development pour structurer et accélérer la stratégie de développement commercial.",
    stageContext: "Contexte",
    stageContext1:
      "Produits SaaS B2B (Tourisme, BTP, Cybersécurité), applications mobiles (jeux)",
    stageContext2:
      "Conception et déploiement de systèmes RAG (Retrieval-Augmented Generation)",
    stageContext3: "Missions de conseil en architecture et stratégie technique",
    stageMissions: "Missions",
    stageMission1:
      "Identifier et prioriser les opportunités commerciales à fort potentiel",
    stageMission2: "Proposer et mettre en œuvre des stratégies d'acquisition",
    stageMission3: "Structurer l'offre et affiner la proposition de valeur",
    stageProfile: "Profil recherché",
    stageProfile1:
      "Étudiant(e) école de commerce, IAE ou double cursus tech/business (L3/M1/M2)",
    stageProfile2: "Intérêt marqué pour la tech et les produits digitaux",
    stageProfile3: "Esprit analytique et structuré",
    stageProfile4:
      "Excellentes capacités rédactionnelles (FR, anglais apprécié)",
    stageProfile5: "Autonomie et curiosité",
    stageBenefits: "Ce que le stage apporte",
    stageBenefit1: "Travail direct avec un CTO / fondateur",
    stageBenefit2: "Vision complète produit ↔ business",
    stageBenefit3: "Impact réel sur des projets en développement",
    stageBenefit4: "Forte responsabilisation",
    stageBenefit5: "Possibilité de collaboration long terme",
    stagePractical: "Infos pratiques",
    stagePractical1: "Stage situé à Grasse.",
    stagePractical2: "Durée : 6 mois.",
    stagePractical5: "Candidature (CV + court message) :",
    stageApply: "Postuler (CV + court message)",
    stageDownloadPdf: "Télécharger l'offre PDF",

    // Offre de stage – Stagiaire Ingénieur
    stageEngineerTitle: "Stagiaire Développeur",
    stageEngineerSubtitle: "Ingénieur Développement / Architecture",
    stageEngineerTagMobile: "Applications Mobiles",
    stageEngineerFounder: "Fondateur",
    stageEngineerIntro1:
      "Entrepreneur et CTO, je développe plusieurs produits technologiques (SaaS B2B, applications mobiles, systèmes RAG).",
    stageEngineerIntro2:
      "Je recherche un(e) stagiaire ingénieur souhaitant s'impliquer dans la conception et l'évolution de ces produits, avec un niveau de responsabilité technique élevé.",
    stageEngineerContext: "Contexte",
    stageEngineerContext1: "Produits SaaS B2B (Tourisme, BTP, Cybersécurité)",
    stageEngineerContext2: "Applications mobiles (jeux et outils métier)",
    stageEngineerContext3:
      "Conception et déploiement de systèmes RAG (Retrieval-Augmented Generation)",
    stageEngineerMissions: "Missions",
    stageEngineerMission1:
      "Concevoir et faire évoluer des architectures backend et mobiles",
    stageEngineerMission2:
      "Participer aux choix techniques structurants (stack, organisation, scalabilité)",
    stageEngineerMission3:
      "Concevoir et optimiser des pipelines RAG (ingestion, embeddings, retrieval, génération)",
    stageEngineerMission4:
      "Contribuer directement à la robustesse et à la performance des produits",
    stageEngineerProfile: "Profil recherché",
    stageEngineerProfile1:
      "Étudiant(e) en école d'ingénieur ou Master informatique (L3/M1/M2)",
    stageEngineerProfile2:
      "Solides bases en algorithmique et conception logicielle",
    stageEngineerProfile3:
      "Intérêt pour l'architecture logicielle et les systèmes distribués",
    stageEngineerProfile4:
      "Curiosité forte pour l'IA appliquée et les systèmes RAG",
    stageEngineerProfile5: "Capacité à proposer, décider et exécuter",
    stageEngineerBenefits: "Ce que le stage apporte",
    stageEngineerBenefit1: "Travail direct avec un CTO / fondateur",
    stageEngineerBenefit2: "Exposition aux décisions techniques structurantes",
    stageEngineerBenefit3: "Impact direct et mesurable sur les produits",
    stageEngineerBenefit4: "Forte responsabilisation",
    stageEngineerBenefit5: "Possibilité de collaboration long terme",
    stageEngineerPractical: "Infos pratiques",
    stageEngineerPractical1: "Stage situé à Grasse.",
    stageEngineerPractical2: "Durée : 6 mois.",
    stageEngineerPractical5: "Candidature (CV + court message) :",
    stageEngineerApply: "Postuler (CV + court message)",
    stageEngineerDownloadPdf: "Télécharger l'offre PDF",
    stageOtherOffer: "Voir aussi : Stagiaire Commercial",
    stageOtherOfferEngineer: "Voir aussi : Stagiaire Développeur",
  },
};

// Helper function to replace placeholders like {company}
export const translate = (key, lang = "en", replacements = {}) => {
  const text = translations[lang]?.[key] || translations.en[key] || key;

  // Check if any replacement is a React element
  const reactReplacements = {};
  const stringReplacements = {};

  Object.keys(replacements).forEach((repl) => {
    const value = replacements[repl];
    if (typeof value === "object" && value && value.$$typeof) {
      reactReplacements[repl] = value;
    } else {
      stringReplacements[repl] = value;
    }
  });

  // Handle string replacements first
  let processedText = text;
  Object.keys(stringReplacements).forEach((repl) => {
    processedText = processedText.replace(
      `{${repl}}`,
      stringReplacements[repl],
    );
  });

  // Handle React element replacements
  if (Object.keys(reactReplacements).length > 0) {
    const elements = [];
    let currentText = processedText;

    Object.keys(reactReplacements).forEach((repl) => {
      const parts = currentText.split(`{${repl}}`);
      if (parts.length > 1) {
        elements.length = 0; // Reset array
        parts.forEach((part, i) => {
          if (part) {
            elements.push(
              <React.Fragment key={`text-${i}`}>{part}</React.Fragment>,
            );
          }
          if (i < parts.length - 1) {
            elements.push(
              <React.Fragment key={`react-${repl}-${i}`}>
                {reactReplacements[repl]}
              </React.Fragment>,
            );
          }
        });
        currentText = ""; // Mark as processed
      }
    });

    return elements.length > 0 ? elements : currentText;
  }

  return processedText;
};
